// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-form {
    width: 60%;
    margin: 40px auto;
    padding: 24px;
    max-width: 1024px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.section {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 35px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    background-color: #fafafa;
}

.section h3 {
    margin-top: 0;
    margin-bottom: 25px;
    font-size: 22px;
    color: #333;
    border-bottom: 1px solid #ddd;
    padding-bottom: 8px;
}

.section label {
    display: flex;
    font-size: 16px;
    margin-bottom: 8px;
}

.sub-label {
    margin-top: 3px;
    margin-bottom: 8px;
    font-size: 14px;
    color: #666;
}

input[type="text"],
input[type="number"],
textarea,
select {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 15px;
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 5px;
}

.cohort-rule-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
}


.cohort-rule-select,
.cohort-rule-tree {
    flex: 0 0 auto;
}

.cohort-rule-select {
    width: 27%;
    max-width: 27%;
}

.cohort-rule-tree {
    width: 63%;
    max-width: 63%;
}

.cohort-rule-actions {
    display: flex;
    gap: 10px;
}

.file-input {
    font-size: 15px;
    margin-top: 5px;
}

.add-btn,
.remove-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 18px;
    padding: 4px 8px;
    border-radius: 4px;
    transition: 0.2s;
}

.add-btn {
    color: #0d6efd;
}

.add-btn:hover {
    background-color: #e7f0ff;
}

.remove-btn {
    color: #dc3545;
    font-size: 20px;
}

.remove-btn:hover {
    background-color: #fdeaea;
}

.inclusion-row:last-child .add-btn {
    margin-left: auto;
}

.submit-wrapper {
    text-align: center;
}

.submit-btn {
    position: relative;
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    border: none;
    background-color: #007bff;
    color: white;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 150px;
    height: 40px;
    justify-self: center;
}

.submit-btn:hover {
    background-color: #084ec1;
}

.submit-btn:disabled {
    background-color: #d6d6d6;
    cursor: not-allowed;
    opacity: 0.6;
}

.spinner {
    border: 3px solid #f3f3f3;
    border-top: 3px solid #3498db;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    animation: spin 2s linear infinite;
    left: 50%;
    top: 50%;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.error-field {
    border: 2px solid #ff3b30 !important;
    background-color: rgba(255, 59, 48, 0.05);
}

.error-message {
    color: #ff3b30;
    font-size: 0.8rem;
    margin-top: 4px;
    margin-bottom: 15px;
}

.form-field {
    margin-bottom: 20px;
}


.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    text-align: center;
    max-width: 400px;
    width: 100%;
}

.modal p {
    margin: 10px 0;
    font-size: 16px;
    color: #333;
}

.error-border {
    border: 2px solid #ff3b30 !important;
}

.form-error {
    color: #ff3b30;
    margin-top: 15px;
    justify-self: center;
}

.required-field::before {
    content: ' *';
    color: #ff3b30;
    margin-right: 3px;
}

.error-text {
    color: #ff3b30;
}

.checkbox-group {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

.checkbox-option {
    display: flex;
    align-items: center;
    gap: 5px;
}

.checkbox-option input[type="checkbox"] {
    margin: 0;
    width: auto;
}

.checkbox-option label {
    margin: 0;
    font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/componentsCSS/ClientForm.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;;;;IAII,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;;AAGA;;IAEI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;AACf;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,SAAS;IACT,eAAe;AACnB","sourcesContent":[".client-form {\n    width: 60%;\n    margin: 40px auto;\n    padding: 24px;\n    max-width: 1024px;\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.section {\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 20px;\n    margin-bottom: 35px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n    background-color: #fafafa;\n}\n\n.section h3 {\n    margin-top: 0;\n    margin-bottom: 25px;\n    font-size: 22px;\n    color: #333;\n    border-bottom: 1px solid #ddd;\n    padding-bottom: 8px;\n}\n\n.section label {\n    display: flex;\n    font-size: 16px;\n    margin-bottom: 8px;\n}\n\n.sub-label {\n    margin-top: 3px;\n    margin-bottom: 8px;\n    font-size: 14px;\n    color: #666;\n}\n\ninput[type=\"text\"],\ninput[type=\"number\"],\ntextarea,\nselect {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    font-size: 15px;\n    width: 100%;\n    box-sizing: border-box;\n    margin-bottom: 5px;\n}\n\n.cohort-rule-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 20px;\n}\n\n\n.cohort-rule-select,\n.cohort-rule-tree {\n    flex: 0 0 auto;\n}\n\n.cohort-rule-select {\n    width: 27%;\n    max-width: 27%;\n}\n\n.cohort-rule-tree {\n    width: 63%;\n    max-width: 63%;\n}\n\n.cohort-rule-actions {\n    display: flex;\n    gap: 10px;\n}\n\n.file-input {\n    font-size: 15px;\n    margin-top: 5px;\n}\n\n.add-btn,\n.remove-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 18px;\n    padding: 4px 8px;\n    border-radius: 4px;\n    transition: 0.2s;\n}\n\n.add-btn {\n    color: #0d6efd;\n}\n\n.add-btn:hover {\n    background-color: #e7f0ff;\n}\n\n.remove-btn {\n    color: #dc3545;\n    font-size: 20px;\n}\n\n.remove-btn:hover {\n    background-color: #fdeaea;\n}\n\n.inclusion-row:last-child .add-btn {\n    margin-left: auto;\n}\n\n.submit-wrapper {\n    text-align: center;\n}\n\n.submit-btn {\n    position: relative;\n    padding: 10px 20px;\n    font-size: 16px;\n    cursor: pointer;\n    border: none;\n    background-color: #007bff;\n    color: white;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 150px;\n    height: 40px;\n    justify-self: center;\n}\n\n.submit-btn:hover {\n    background-color: #084ec1;\n}\n\n.submit-btn:disabled {\n    background-color: #d6d6d6;\n    cursor: not-allowed;\n    opacity: 0.6;\n}\n\n.spinner {\n    border: 3px solid #f3f3f3;\n    border-top: 3px solid #3498db;\n    border-radius: 50%;\n    width: 25px;\n    height: 25px;\n    animation: spin 2s linear infinite;\n    left: 50%;\n    top: 50%;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.error-field {\n    border: 2px solid #ff3b30 !important;\n    background-color: rgba(255, 59, 48, 0.05);\n}\n\n.error-message {\n    color: #ff3b30;\n    font-size: 0.8rem;\n    margin-top: 4px;\n    margin-bottom: 15px;\n}\n\n.form-field {\n    margin-bottom: 20px;\n}\n\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal {\n    background-color: white;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    text-align: center;\n    max-width: 400px;\n    width: 100%;\n}\n\n.modal p {\n    margin: 10px 0;\n    font-size: 16px;\n    color: #333;\n}\n\n.error-border {\n    border: 2px solid #ff3b30 !important;\n}\n\n.form-error {\n    color: #ff3b30;\n    margin-top: 15px;\n    justify-self: center;\n}\n\n.required-field::before {\n    content: ' *';\n    color: #ff3b30;\n    margin-right: 3px;\n}\n\n.error-text {\n    color: #ff3b30;\n}\n\n.checkbox-group {\n    display: flex;\n    gap: 20px;\n    margin-bottom: 20px;\n}\n\n.checkbox-option {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.checkbox-option input[type=\"checkbox\"] {\n    margin: 0;\n    width: auto;\n}\n\n.checkbox-option label {\n    margin: 0;\n    font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
